<!-- [formGroup]="matterdetailForm" -->
<form
  name="CompensationForm"
  id="CompensationForm"
  [formGroup]="CompensationForm"
  fxLayout="column"
  fxLayoutAlign="start"
  class="one"
  fxFlex="1 0 auto"
>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.ACCIDENTDATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.ACCIDENTDATE),
      }"
    >
      <mat-label>Accident Date</mat-label>
      <input
        (dateInput)="AccidentDateClick('input', $event)"
        matTooltip="{{ toolTipList ? toolTipList?.ACCIDENTDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="ACCIDENTDATETEXT"
        (dateChange)="AccidentDateClick('change', $event)"
        matInput
        [matDatepicker]="AccidentDate"
      />
      <mat-datepicker-toggle matSuffix [for]="AccidentDate"></mat-datepicker-toggle>
      <mat-datepicker #AccidentDate></mat-datepicker>
      @if (testBool && toolTipList?.ACCIDENTDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.ACCIDENTDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.ACCIDENTDATE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.ACCIDENTDATE2),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.ACCIDENTDATE2),
      }"
    >
      <mat-label>Accident Date 2</mat-label>
      <input
        matTooltip="{{ toolTipList ? toolTipList?.ACCIDENTDATE2?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="ACCIDENTDATE2TEXT"
        (dateInput)="AccidentDate2Click('input', $event)"
        (dateChange)="AccidentDate2Click('change', $event)"
        matInput
        [matDatepicker]="AccidentDate2"
      />
      <mat-datepicker-toggle matSuffix [for]="AccidentDate2"></mat-datepicker-toggle>
      <mat-datepicker #AccidentDate2></mat-datepicker>
      @if (testBool && toolTipList?.ACCIDENTDATE2) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.ACCIDENTDATE2.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.ACCIDENTDATE2?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.ACCIDENTDATE3),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.ACCIDENTDATE3),
      }"
    >
      <mat-label>Accident Date 3</mat-label>
      <input
        matTooltip="{{ toolTipList ? toolTipList?.ACCIDENTDATE3?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="ACCIDENTDATE3TEXT"
        (dateInput)="AccidentDate3Click('input', $event)"
        (dateChange)="AccidentDate3Click('change', $event)"
        matInput
        [matDatepicker]="AccidentDate3"
      />
      <mat-datepicker-toggle matSuffix [for]="AccidentDate3"></mat-datepicker-toggle>
      <mat-datepicker #AccidentDate3></mat-datepicker>
      @if (testBool && toolTipList?.ACCIDENTDATE3) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.ACCIDENTDATE3.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.ACCIDENTDATE3?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.ACCIDENTDATE4),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.ACCIDENTDATE4),
      }"
    >
      <mat-label>Accident Date 4</mat-label>
      <input
        matTooltip="{{ toolTipList ? toolTipList?.ACCIDENTDATE4?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="ACCIDENTDATE4TEXT"
        (dateInput)="AccidentDate4Click('input', $event)"
        (dateChange)="AccidentDate4Click('change', $event)"
        matInput
        [matDatepicker]="AccidentDate4"
      />
      <mat-datepicker-toggle matSuffix [for]="AccidentDate4"></mat-datepicker-toggle>
      <mat-datepicker #AccidentDate4></mat-datepicker>
      @if (testBool && toolTipList?.ACCIDENTDATE4) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.ACCIDENTDATE4.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.ACCIDENTDATE4?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.EXPIRATIONDATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.EXPIRATIONDATE),
      }"
    >
      <mat-label>Expiry Date</mat-label>
      <input
        (dateInput)="ExpiryDateClick('input', $event)"
        matTooltip="{{ toolTipList ? toolTipList?.EXPIRATIONDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="EXPIRATIONDATETEXT"
        (dateChange)="ExpiryDateClick('change', $event)"
        matInput
        [matDatepicker]="ExpiryDate"
      />
      <mat-datepicker-toggle matSuffix [for]="ExpiryDate"></mat-datepicker-toggle>
      <mat-datepicker #ExpiryDate></mat-datepicker>
      @if (testBool && toolTipList?.EXPIRATIONDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.EXPIRATIONDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.EXPIRATIONDATE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.DATEOFNOTICEOFINJURY),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.DATEOFNOTICEOFINJURY),
      }"
    >
      <mat-label>Notice of Injury</mat-label>
      <input
        (dateInput)="NoticeofInjuryClick('input', $event)"
        matTooltip="{{ toolTipList ? toolTipList?.DATEOFNOTICEOFINJURY?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="DATEOFNOTICEOFINJURYTEXT"
        (dateChange)="NoticeofInjuryClick('change', $event)"
        matInput
        [matDatepicker]="NoticeofInjury"
      />
      <mat-datepicker-toggle matSuffix [for]="NoticeofInjury"></mat-datepicker-toggle>
      <mat-datepicker #NoticeofInjury></mat-datepicker>
      @if (testBool && toolTipList?.DATEOFNOTICEOFINJURY) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.DATEOFNOTICEOFINJURY.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.DATEOFNOTICEOFINJURY?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.PLACEOFINJURY),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PLACEOFINJURY),
      }"
    >
      <mat-label>Place of Injury</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList?.PLACEOFINJURY?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="PLACEOFINJURY"
      />
      @if (testBool && toolTipList?.PLACEOFINJURY) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.PLACEOFINJURY.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.PLACEOFINJURY?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.INJURYDESCRIPTION),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.INJURYDESCRIPTION),
      }"
    >
      <mat-label>Injury Desc.</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList?.INJURYDESCRIPTION?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="INJURYDESCRIPTION"
      />
      @if (testBool && toolTipList?.INJURYDESCRIPTION) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.INJURYDESCRIPTION.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.INJURYDESCRIPTION?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.HOWDIDINJURYOCCUR),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.HOWDIDINJURYOCCUR),
      }"
    >
      <mat-label>Cause of Injury</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList?.COURT?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="HOWDIDINJURYOCCUR"
      />
      @if (testBool && toolTipList?.HOWDIDINJURYOCCUR) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.HOWDIDINJURYOCCUR.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.HOWDIDINJURYOCCUR?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" class="checkbox-row pr-1">
    <mat-form-field
      appearance="outline"
      fxFlex="50"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.LITIGATIONFUNDER),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.LITIGATIONFUNDER),
      }"
    >
      <mat-label>Lit. Funder</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList?.LITIGATIONFUNDER?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="LITIGATIONFUNDER"
      />
      @if (testBool && toolTipList?.LITIGATIONFUNDER) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.LITIGATIONFUNDER.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.LITIGATIONFUNDER?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <section
      class="example-section"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.NUMBEROFSHARES),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.NUMBEROFSHARES),
      }"
    >
      <mat-checkbox
        class="checkbox-width"
        matTooltip="{{ toolTipList ? toolTipList?.COURT?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="TRANSFERREDFROMOTHERSOLICITOR"
      >
        Transferred From Other Solicitor
      </mat-checkbox>
    </section>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.OTHERSOLICITORNAME),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.OTHERSOLICITORNAME),
      }"
    >
      <mat-label>Solicitor Name</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList?.OTHERSOLICITORNAME?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="OTHERSOLICITORNAME"
      />
      @if (testBool && toolTipList?.OTHERSOLICITORNAME) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.OTHERSOLICITORNAME.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.OTHERSOLICITORNAME?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.ESTIMATEDAWARD),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.ESTIMATEDAWARD),
      }"
    >
      <mat-label>Est. Award</mat-label>
      <input
        matInput
        style="text-align: right"
        type="text"
        mask="separator.2"
        thousandSeparator=","
        decimalMarker="."
        matTooltip="{{ toolTipList ? toolTipList?.ESTIMATEDAWARD?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="ESTIMATEDAWARD"
        [leadZero]="true"
      />
      @if (testBool && toolTipList?.ESTIMATEDAWARD) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.ESTIMATEDAWARD.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.ESTIMATEDAWARD?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.CLAIMNUMBER),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.CLAIMNUMBER),
      }"
    >
      <mat-label>Claim Number</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList?.CLAIMNUMBER?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="CLAIMNUMBER"
      />
      @if (testBool && toolTipList?.CLAIMNUMBER) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.CLAIMNUMBER.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.CLAIMNUMBER?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="34"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.INVESTIGATIONDATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.INVESTIGATIONDATE),
      }"
    >
      <mat-label>Investigation Date</mat-label>
      <input
        (dateInput)="InvestigationClick('input', $event)"
        matTooltip="{{ toolTipList ? toolTipList?.INVESTIGATIONDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="INVESTIGATIONDATETEXT"
        (dateChange)="InvestigationClick('change', $event)"
        matInput
        name="Investigation"
        [matDatepicker]="Investigation"
        matTooltip="{{ toolTipList?.INVESTIGATIONDATE || '' }}"
      />
      <mat-datepicker-toggle matSuffix [for]="Investigation"></mat-datepicker-toggle>
      <mat-datepicker #Investigation></mat-datepicker>
      @if (testBool && toolTipList?.INVESTIGATIONDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.INVESTIGATIONDATE?.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.INVESTIGATIONDATE?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      fxFlex="50"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.SETTLEMENTDATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.SETTLEMENTDATE),
      }"
    >
      <mat-label>Settlement Date</mat-label>
      <input
        (dateInput)="SettlementDateClick('input', $event)"
        matTooltip="{{ toolTipList ? toolTipList?.SETTLEMENTDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="SETTLEMENTDATETEXT"
        (dateChange)="SettlementDateClick('change', $event)"
        matInput
        name="SettlementDate"
        [matDatepicker]="SettlementDate"
        matTooltip="{{ toolTipList?.SETTLEMENTDATE || '' }}"
      />
      <mat-datepicker-toggle matSuffix [for]="SettlementDate"></mat-datepicker-toggle>
      <mat-datepicker #SettlementDate></mat-datepicker>
      @if (testBool && toolTipList?.SETTLEMENTDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.SETTLEMENTDATE?.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.SETTLEMENTDATE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
</form>
